import React from 'react';
import PropTypes from 'prop-types';

import Safe from './Safe';

const Avatar = props => (
  <div className='avatar'>
    {props.user.username &&
      <div className='picture'>
        {!props.user.picture ? <i
          className='fas fa-user-circle'
          style={{
            width: '24px',
            height: '24px',
            fontSize: '24px',
            marginTop: '-5px',
          }}
        /> : null}
        {props.user.picture ? <img
          style={{
            fontSize: '23px',
            position: 'relative',
            border: '1px solid #FFF',
            borderRadius: '24px',
            width: '24px',
            height: '24px',
            overflow: 'hidden',
            top: '-5px',
          }}
          alt={props.user.username}
          src={props.user.picture}
        /> : null }
      </div>
    }
    {props.name !== false ?
      <div className='name'>
        <Safe
          text={`${props.user.firstname} ${props.user.lastname}`}
          safe={false}
        />
      </div> : null
    }
  </div>
);

Avatar.propTypes = {
  user: PropTypes.shape({
    picture: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
    username: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
  }),
  name: PropTypes.bool,
};

Avatar.defaultProps = {
  user: {
    picture: '',
    username: '',
    firstname: '',
    lastname: '',
  },
  name: true,
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/views/Components/Avatar.js